import type { ZodSchema, z } from 'zod';
import { defaultZodErrorParser, type ZodErrorParser } from './defaultZodErrorParser';
import { type ErrorContext, normalizeErrorMessage } from './errorType';

export const validateSchemaAsync =
  <S extends ZodSchema>(
    schema: S,
    context: ErrorContext<S>,
    customZodErrorParser?: ZodErrorParser,
  ) =>
  async (data: Promise<z.input<S>>): Promise<z.infer<S>> => {
    const resolved = await data;
    const parsedResult = schema.safeParse(resolved);
    const errorParser = customZodErrorParser || defaultZodErrorParser;

    if (!parsedResult.success) {
      const parsedErrors = parsedResult.error ? errorParser(parsedResult.error) : [];
      const errorMessage = normalizeErrorMessage(context, parsedErrors.join('\n'));
      throw new Error(errorMessage);
    }

    return parsedResult.data;
  };
